import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock, Zap, ShieldCheck } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { PricingTiers } from './PricingTiers';
export function HeroSection() {
  const [selectedTier, setSelectedTier] = useState<'standard' | 'bundle'>('bundle');
  return <section className="pt-8 pb-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-80">
      {/* Top Badge */}
      <div className="flex justify-center mb-8" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center px-4 py-1.5 rounded-full border border-primary/50 bg-primary/10 text-primary text-sm font-bold tracking-wide" data-id="element-82">
          <Clock className="w-4 h-4 mr-2" data-id="element-83" />
          OFERTA POR TIEMPO LIMITADO
        </motion.div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-84">
        {/* Left: Product Video */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="relative rounded-2xl overflow-hidden glow-border aspect-square lg:aspect-auto lg:h-[700px] bg-black" data-id="element-85">
          <video src="https://cdn.magicpatterns.com/uploads/3sH9nyuuQ61W3sBnR5oPnE/Video inicial recursos.mp4" autoPlay controls playsInline className="w-full h-full object-cover" data-id="element-86" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-60 pointer-events-none" data-id="element-87"></div>
        </motion.div>

        {/* Right: Product Details */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-surface rounded-2xl p-6 md:p-8 glow-border" data-id="element-88">
          <h1 className="text-3xl md:text-4xl font-black uppercase tracking-tight mb-4 text-white" data-id="element-89">
            PACK DE EDICIÓN DEFINITIVO 2026
          </h1>

          <div className="flex items-center space-x-2 mb-6 text-xs md:text-sm font-bold" data-id="element-90">
            <div className="flex text-primary" data-id="element-91">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20" data-id="element-92">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-93" />
                </svg>)}
            </div>
            <span className="text-white" data-id="element-94">EXCELENTE</span>
            <span className="text-primary" data-id="element-95">4.9/5</span>
            <span className="text-primary" data-id="element-96">582 RESEÑAS VERIFICADAS</span>
          </div>

          <ul className="space-y-3 mb-8" data-id="element-97">
            {['AHORRA HORAS DE TRABAJO REPETITIVO', 'LOOK PROFESIONAL SIN NECESIDAD DE PLUGINS', 'USADO EN PRODUCCIONES DE ALTO NIVEL', 'ACTUALIZACIONES GRATUITAS PARA SIEMPRE'].map((benefit, i) => <li key={i} className="flex items-center text-sm font-bold tracking-wide" data-id="element-98">
                <Check className="w-5 h-5 text-primary mr-3 flex-shrink-0" data-id="element-99" />
                {benefit}
              </li>)}
          </ul>

          <div className="flex justify-center mb-2" data-id="element-100">
            <div className="inline-flex items-center justify-center bg-primary/10 border border-primary/30 rounded-2xl py-3 px-8" data-id="element-101">
              <span className="text-primary font-black text-4xl md:text-5xl mr-3 glow-text" data-id="element-102">
                $29.000
              </span>
              <span className="text-textSecondary line-through text-lg font-bold" data-id="element-103">
                $769.000
              </span>
            </div>
          </div>

          <CountdownTimer data-id="element-104" />

          <PricingTiers selectedTier={selectedTier} onSelectTier={setSelectedTier} data-id="element-105" />

          <a href={selectedTier === 'standard' ? 'https://brunocairo.com/cart/50635899175145:1' : 'https://brunocairo.com/cart/50636149457129:1'} target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-blue-600 to-primary hover:from-primary hover:to-blue-400 text-white font-black text-lg py-4 rounded-xl uppercase tracking-wider transition-all duration-300 transform hover:scale-[1.02] shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] mb-6 text-center" data-id="element-106">
            {selectedTier === 'standard' ? 'COMPRAR 2026 EDITING ARSENAL' : 'COMPRAR EDICIÓN PRO 2026'}
          </a>

          <div className="flex flex-col items-center space-y-4" data-id="element-107">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm font-bold text-textSecondary" data-id="element-108">
              <span className="flex items-center" data-id="element-109">
                <Zap className="w-4 h-4 text-primary mr-2 fill-current" data-id="element-110" />{' '}
                Descarga instantánea
              </span>
              <span className="flex items-center" data-id="element-111">
                <Zap className="w-4 h-4 text-primary mr-2 fill-current" data-id="element-112" />{' '}
                Actualizaciones de por vida
              </span>
            </div>

            <div className="w-full h-px bg-surface border-t border-primary/20 my-2" data-id="element-113"></div>

            <p className="text-primary font-bold text-sm" data-id="element-114">
              187 editores confiaron en nosotros este mes
            </p>

            <p className="flex items-center text-primary font-bold text-xs text-center" data-id="element-115">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-116" />
              Garantía de 7 días, si no te sirve, te devolvemos el dinero.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Social Proof & Compatibility Banner */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="mt-12 max-w-4xl mx-auto text-center" data-id="element-117">
        <p className="text-sm md:text-base font-black uppercase tracking-wide mb-2" data-id="element-118">
          RECURSOS UTILIZADOS EN{' '}
          <span className="text-primary" data-id="element-119">
            CIENTOS DE CANALES CON MILLONES DE SEGUIDORES
          </span>
        </p>
        <p className="text-xs md:text-sm text-textSecondary font-bold uppercase tracking-wider mb-6" data-id="element-120">
          COMPATIBLE Y TESTEADO EN TODOS LOS PROGRAMAS DE EDICIÓN
        </p>
        <div className="flex items-center justify-center gap-3 md:gap-4 flex-wrap" data-id="element-121">
          {/* Lightroom */}
          <img src="https://upload.wikimedia.org/wikipedia/commons/b/b6/Adobe_Photoshop_Lightroom_CC_logo.svg" alt="Adobe Lightroom" className="w-10 h-10 md:w-12 md:h-12 rounded-xl" data-id="element-122" />
          {/* Photoshop */}
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg" alt="Adobe Photoshop" className="w-10 h-10 md:w-12 md:h-12 rounded-xl" data-id="element-123" />
          {/* After Effects */}
          <img src="https://upload.wikimedia.org/wikipedia/commons/c/cb/Adobe_After_Effects_CC_icon.svg" alt="Adobe After Effects" className="w-10 h-10 md:w-12 md:h-12 rounded-xl" data-id="element-124" />
          {/* Premiere Pro */}
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/40/Adobe_Premiere_Pro_CC_icon.svg" alt="Adobe Premiere Pro" className="w-10 h-10 md:w-12 md:h-12 rounded-xl" data-id="element-125" />
          {/* DaVinci Resolve */}
          <img src="https://upload.wikimedia.org/wikipedia/commons/9/90/DaVinci_Resolve_17_logo.svg" alt="DaVinci Resolve" className="w-10 h-10 md:w-12 md:h-12 rounded-xl" data-id="element-126" />
          {/* Vegas Pro */}
          <img src="https://cdn.magicpatterns.com/uploads/eHbt1CaeX1X5xGmBpDW4Fm/pasted-image.png" alt="Vegas Pro" className="w-10 h-10 md:w-12 md:h-12 rounded-xl object-cover" data-id="element-127" />
          {/* CapCut */}
          <img src="https://cdn.magicpatterns.com/uploads/wmu2WQe6xXC9fSVsE69yG1/pasted-image.png" alt="CapCut" className="w-12 h-12 md:w-14 md:h-14 rounded-xl object-cover" data-id="element-128" />
          {/* Final Cut Pro */}
          <img src="https://cdn.icon-icons.com/icons2/3053/PNG/512/final_cut_pro_macos_bigsur_icon_190177.png" alt="Final Cut Pro" className="w-10 h-10 md:w-12 md:h-12 rounded-xl object-contain" data-id="element-129" />
        </div>

        {/* Creators Carousel */}
        <div className="mt-8 overflow-hidden w-full" data-id="element-130">
          <div className="flex animate-marquee w-max" data-id="element-131">
            {[...Array(2)].map((_, setIndex) => <div key={setIndex} className="flex items-center gap-8 md:gap-12 px-4" data-id="element-132">
                {[{
              name: 'Alejandro Salomon',
              followers: '+1.2M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/94iwVmekYXZzZcBvgyWbRm/pasted-image.jpg'
            }, {
              name: 'Joven Inversor',
              followers: '+1.1M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/kKwTwC9Jxfz5MPFg9fvcxe/pasted-image.jpg'
            }, {
              name: 'Crypto Norber',
              followers: '+442K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/fRgCB9DEN4gMVsmrerLxWh/pasted-image.jpg'
            }, {
              name: 'Top 5 Best',
              followers: '+5.4M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/cPtXpVEXbPfV4v3hSb9XBg/pasted-image.jpg'
            }, {
              name: 'Fabss',
              followers: '+720K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/mfC5Kz7sjbSG4o4iMmQoED/pasted-image.jpg'
            }, {
              name: 'School of Hard Knocks',
              followers: '+10M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/wrRdisbAxMR5k2Ru4PE8qU/imagen_2026-03-17_092414377.png'
            }, {
              name: 'Ramiro Cubria',
              followers: '+500K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/7rTMcAaZ7qshacv5qkrfs5/pasted-image.jpg'
            }, {
              name: 'JuegaGerman',
              followers: '+55M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/7DSA68XJTDuKRJ1yxBsRfj/pasted-image.jpg'
            }, {
              name: 'Balducs',
              followers: '+90K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/qoScj9ZME9skwATmHjvjux/pasted-image.jpg'
            }, {
              name: 'Iñaki Zugasti',
              followers: '+180K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/uAdQpW6wvvDa5CD8LJYwFN/pasted-image.jpg'
            }, {
              name: 'Overdogs USA',
              followers: '+282K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/7V2cPxodb7REi7aNACRGko/pasted-image.jpg'
            }, {
              name: 'Overdogs ESP',
              followers: '+205K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/n9y4NA8AGxiQvGfkfSuZbx/pasted-image.jpg'
            }, {
              name: 'Znorux',
              followers: '+554K Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/79xKjJgfhhqy8PBkHEsmD4/image.png'
            }, {
              name: 'MarkiLokuras',
              followers: '+1.02M Seguidores',
              img: 'https://cdn.magicpatterns.com/uploads/pMBJD3HhCjSqReVwqeLfNC/pasted-image.jpg'
            }].map((creator, i) => <div key={`${setIndex}-${i}`} className="flex flex-col items-center gap-1.5 flex-shrink-0" data-id="element-133">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden border-2 border-primary/40 shadow-[0_0_12px_rgba(59,130,246,0.25)]" data-id="element-134">
                      <img src={creator.img} alt={creator.name} className={`w-full h-full object-cover ${creator.name === 'Alejandro Salomon' ? 'scale-150 object-center' : ''}`} data-id="element-135" />
                    </div>
                    <span className="text-xs md:text-sm font-bold text-white whitespace-nowrap" data-id="element-136">
                      {creator.name}
                    </span>
                    <span className="text-[10px] md:text-xs font-semibold text-primary whitespace-nowrap" data-id="element-137">
                      {creator.followers}
                    </span>
                  </div>)}
              </div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}